//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";
import {setupRecaptcha} from "./recaptcha";


//Bootstrap JS
import * as bootstrap from 'bootstrap';
import {hide} from "@popperjs/core";

import {atcb_init} from 'add-to-calendar-button';

import {initiateProductPage} from "./product-page";
import {initiateVatToggle} from "./vat-toggle";
import {initializeAddressSearch} from "./search-address";
import {
    initiateBranchPage,
    initializeFindBranchMap,
    initializeMapSearch,
    initializeBranchFullMap,
    initializeBranchMap
} from "./branch-page";
import {initiateTypeAheadSearch} from "./type-ahead-search";
import {initConfirmationModal} from "./confirmation-modal";
import {initiateRefineResults} from "./refine-results";
import {initiateNavigation} from "./navigation";
import {initiateProductPagePushState} from "./product-search-push-state";
import {initiateComponents} from "./initializeComponents";
import {initBasket} from "./basket";
import {initClickAndCollectBranch} from "./click-and-collect-branch";
import {initAddToCart} from "./add-to-cart";
import {initializeChooseBranchMap} from "./choose-branch";
import {initEnterEmail} from "./enter-email";
import {initShortListOperation} from "./shortlist";
import {initDeliveryPostcode} from "./delivery-postcode";
import {initCheckoutPostcode} from "./checkout-postcode";
import {initButtonLoader} from "./button-loader";
import {initiatePayment} from "./setup-payment";
import {initiate_Carousels} from "./carousels";
import {initiateCookieConsent} from "./cookie-consent";
import  {initAlertBarDismiss} from "./alert-bar";
import {initPayments} from "./payments";
import {initDateDuration} from "./date-duration";
import {InitOrderShowMore} from "./order-show-more";

$(() => {
    let requestVerificationToken = $('body').data('antiforgery-token');
    $.ajaxSetup({
        cache: false,
        headers: {
            'RequestVerificationToken': requestVerificationToken
        }
    });
    
    initiateVatToggle();
    initiate_Carousels();
    initiateProductPage();
    initiateBranchPage();
    initiateTypeAheadSearch();
    initConfirmationModal();
    initiateRefineResults();
    initiateNavigation();
    initiateProductPagePushState();
    initiateComponents();
    initAddToCart();
    initBasket();
    initDeliveryPostcode();
    initCheckoutPostcode()
    initClickAndCollectBranch();
    initEnterEmail();
    initShortListOperation();
    initButtonLoader();
    initiatePayment();
    initiateCookieConsent();
    initAlertBarDismiss();
    initDateDuration();
    InitOrderShowMore();
    initPayments();
});

window["recaptchaOnLoad"] = function (){
    setupRecaptcha();
}

//Initiate Maps
window["initMaps"] = function () {
    initializeFindBranchMap();
    initializeBranchMap();
    initializeBranchFullMap();
    initializeMapSearch();
    initializeAddressSearch();
    initializeChooseBranchMap();
}

